import React, { createContext, useContext } from 'react'
import { useSelector } from 'react-redux';

const PermissionContext = createContext({
    userPermissions: [],
    checkPermission: () => { }
});

const PermissionContextProvider = ({ children }) => {

    const userPermissions = useSelector(({ auth }) => {
        if (!!auth && !!auth.login && !!auth.login.currentUser && !!auth.login.currentUser.permissions) {
            return auth.login.currentUser.permissions
        } else {
            return [];
        }
    })

    const checkPermission = (permissions, anyOne) => {
        let isValid = userPermissions.length > 0;
        permissions = Array.isArray(permissions) ? permissions : [permissions];
        for (let i = 0; i < permissions.length; i++) {
            isValid = isValid && userPermissions.includes(permissions[i]);

            if (isValid) {
                if (anyOne) {
                    return true;
                }
            } else {
                return false;
            }
        }

        return isValid;
    }

    return (
        <PermissionContext.Provider
            value={{
                checkPermission,
                userPermissions
            }}
        >
            {children}
        </PermissionContext.Provider>
    )
}

const usePermissionContext = () => {
    return useContext(PermissionContext)
}

export { PermissionContextProvider, usePermissionContext };
